import { makeAutoObservable } from "mobx";
import type { EpisodesApi } from "@/api/episodes";
import type { PodcastsApi } from "@/api/podcasts";
import { Resource } from "./Resource";

/** What the page for a language (English) shows: its podcasts and its latest episodes. */
export class LanguageStore {
    readonly podcastList: Resource<Podcast[], string>;
    readonly latestEpisodes: Resource<Episode[], string>;

    constructor(
        private readonly podcastsApi: PodcastsApi,
        private readonly episodesApi: EpisodesApi
    ) {
        this.podcastList = new Resource((lang) => this.podcastsApi.byLanguage(lang));
        this.latestEpisodes = new Resource((lang) => this.episodesApi.latest({ lang, onlyToplist: 1 }, 1));

        makeAutoObservable<LanguageStore, "podcastsApi" | "episodesApi">(this, {
            podcastsApi: false,
            episodesApi: false,
            podcastList: false,
            latestEpisodes: false,
        });
    }

    get podcasts(): Podcast[] {
        return this.podcastList.data ?? [];
    }

    get latest(): Episode[] {
        return this.latestEpisodes.data ?? [];
    }

    /** Loads both for `lang`, each unless it is already loaded. Failures end up in the resources' `error`. */
    async load(lang: string) {
        await Promise.all([this.podcastList.load(lang), this.latestEpisodes.load(lang)]);
    }
}
